import { c as _c } from "react/compiler-runtime";
import { Checkmark4Icon, Text } from "@flat-ui";
import { Stack } from "@mui-wrapper";
/**
 * A component that displays a feature item with a checkmark icon and descriptive text.
 * Used within credit package displays to list included features or benefits.
 */
export function CreditFeatureItem(t0) {
  const $ = _c(4);
  const {
    featureText
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      marginBottom: "15px",
      alignItems: "flex-start"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Checkmark4Icon sx={{
      color: "primary.main",
      width: "24px",
      height: "24px"
    }} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== featureText) {
    t3 = <Stack direction="row" spacing={1} sx={t1}>{t2}<Text variant="bodyM">{featureText}</Text></Stack>;
    $[2] = featureText;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}